// 操作权限控制

// 返回true表示有权限, 否则无权限
export type CmdRightProvider = (cmd: string) => boolean;

let cmdRightProvider: CmdRightProvider | undefined;

export function canAccess(cmd?: string) {
  if (!cmd || !cmdRightProvider) return true;

  return cmdRightProvider(cmd);
}

export function setCmdRightProvider(p: CmdRightProvider) {
  cmdRightProvider = p;
}
